// 「金幣用完」提示：免費將數用完、金幣輸光、金幣不夠入座時跳出，引導去商店
// 對應 docs/PRD-Freemium.md 第 6.1 節：每天最多主動跳出一次，避免像在討錢
// 以自己購買為主，「請人幫忙付」只在說明裡帶一句；文案不提「孩子」
//
// === 使用圖片 ===
// - public/assets/ui/shop-card.png — 月卡圖（Codex 產圖）
// 其餘為純程式繪製（DOM overlay，不經 Phaser）

const PROMPT_ID = 'mahjong-help-prompt';
const PROMPT_DAY_KEY = 'mahjongking.help-prompt-day'; // 今天是否已經跳過
const PROMPT_Z_INDEX = '1950';
const OVERLAY_BG = 'rgba(0, 0, 0, 0.6)';
const CARD_BG = '#fff8ec';
const CARD_MAX_WIDTH_PX = 520;
const TITLE_FONT_PX = 32;
const BODY_FONT_PX = 22;
const BUTTON_FONT_PX = 26;
const IMAGE_PX = 140;
const RED = '#a0322a';

const today = (): string => new Date(Date.now() + 8 * 3600_000).toISOString().slice(0, 10);

const alreadyPromptedToday = (): boolean => {
  try {
    return localStorage.getItem(PROMPT_DAY_KEY) === today();
  } catch {
    return false;
  }
};

const markPrompted = (): void => {
  try {
    localStorage.setItem(PROMPT_DAY_KEY, today());
  } catch {
    /* 寫不進去就算了，頂多同一天多跳一次 */
  }
};

/** 每天最多跳一次；按「去商店看看」呼叫 onHelp（開商店）。回傳是否真的跳出。 */
export const maybeShowHelpPrompt = (title: string, onHelp: () => void): boolean => {
  if (typeof document === 'undefined' || alreadyPromptedToday()) return false;
  if (document.getElementById(PROMPT_ID)) return false;
  markPrompted();
  const overlay = document.createElement('div');
  overlay.id = PROMPT_ID;
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    zIndex: PROMPT_Z_INDEX,
    background: OVERLAY_BG,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  });
  const card = document.createElement('div');
  Object.assign(card.style, {
    background: CARD_BG,
    maxWidth: `${CARD_MAX_WIDTH_PX}px`,
    borderRadius: '22px',
    padding: '24px 28px',
    textAlign: 'center',
    color: '#3a2a1a',
    fontFamily: '"PingFang TC", "Microsoft JhengHei", system-ui, sans-serif',
  });
  const image = document.createElement('img');
  image.src = 'assets/ui/shop-card.png';
  Object.assign(image.style, { width: `${IMAGE_PX}px`, height: 'auto' });
  const heading = document.createElement('div');
  heading.textContent = title;
  Object.assign(heading.style, {
    fontSize: `${TITLE_FONT_PX}px`,
    fontWeight: 'bold',
    marginTop: '8px',
  });
  const body = document.createElement('div');
  body.textContent = '買張月卡就不限將數，每天還多領金幣。\n也可以傳 LINE 請人幫忙付。';
  Object.assign(body.style, {
    fontSize: `${BODY_FONT_PX}px`,
    margin: '12px 0 20px',
    lineHeight: '1.5',
    whiteSpace: 'pre-line',
  });
  const close = (): void => overlay.remove();
  const button = (label: string, primary: boolean, onClick: () => void): HTMLButtonElement => {
    const b = document.createElement('button');
    b.textContent = label;
    Object.assign(b.style, {
      fontSize: `${BUTTON_FONT_PX}px`,
      padding: '14px 28px',
      margin: '6px',
      borderRadius: '14px',
      border: primary ? 'none' : `2px solid ${RED}`,
      background: primary ? RED : 'transparent',
      color: primary ? '#fff' : RED,
      fontWeight: 'bold',
      cursor: 'pointer',
    });
    b.addEventListener('click', onClick);
    return b;
  };
  card.append(
    image,
    heading,
    body,
    button('去商店看看', true, () => {
      close();
      onHelp();
    }),
    button('下次再說', false, close)
  );
  overlay.append(card);
  document.body.append(overlay);
  return true;
};
